import { PropsWithChildren } from 'react';

import { LoadingIcon } from '@/components/common';

import { Alert } from './Alert';

interface IAlertLoadingProps extends PropsWithChildren {
  readonly title: string;
  readonly description?: string;
}

export function AlertLoading({
  title,
  description,
  children,
}: IAlertLoadingProps) {
  return (
    <Alert
      icon={<LoadingIcon className="w-12 animate-spin-slow text-primary" />}
      title={title}
      description={description}
    >
      {children}
    </Alert>
  );
}
